'use client';

import { useMemo } from 'react';
import { useBannerSections } from '@/common/apis/home/banners';
import { useLandingCategories } from '@/common/apis/home/categories';
import {
  useHomeCarouselVendors,
  useHomeCarousels,
} from '@/common/apis/home/home-carousels';
import { PLP_VENDORS_CAROUSEL } from '@/common/types/home-carousel.type';
import { mapShopHomeData } from '@/features/shop/data/shop-home.mappers';

const NEW_VENDORS_HOME_PAGE_SIZE = 12;

export function useShopHomeData() {
  const bannersQuery = useBannerSections();
  const carouselsQuery = useHomeCarousels();
  const categoriesQuery = useLandingCategories();
  const newVendorsQuery = useHomeCarouselVendors(PLP_VENDORS_CAROUSEL, {
    pageIndex: 0,
    pageSize: NEW_VENDORS_HOME_PAGE_SIZE,
  });

  const isPending =
    (bannersQuery.isPending && !bannersQuery.data) ||
    (carouselsQuery.isPending && !carouselsQuery.data) ||
    (categoriesQuery.isPending && !categoriesQuery.data) ||
    (newVendorsQuery.isPending && !newVendorsQuery.data);

  const data = useMemo(() => {
    if (isPending) return undefined;

    return mapShopHomeData(
      bannersQuery.data?.data?.sections ?? [],
      carouselsQuery.data?.data?.items ?? [],
      categoriesQuery.data?.data?.items ?? [],
      newVendorsQuery.data?.data?.vendors ?? []
    );
  }, [
    bannersQuery.data?.data?.sections,
    carouselsQuery.data?.data?.items,
    categoriesQuery.data?.data?.items,
    isPending,
    newVendorsQuery.data?.data?.vendors,
  ]);

  return {
    data,
    isPending,
    isError:
      bannersQuery.isError ||
      carouselsQuery.isError ||
      categoriesQuery.isError ||
      newVendorsQuery.isError,
  };
}
